import { render, staticRenderFns } from "./PromotionGroupLookup.vue?vue&type=template&id=63ce5b9a&lang=pug"
import script from "./PromotionGroupLookup.vue?vue&type=script&lang=js"
export * from "./PromotionGroupLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports